var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubbleSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_4382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.49487C10.194 1.49413 8.41844 1.95946 6.84499 2.84586C5.27153 3.73226 3.95346 5.00972 3.01826 6.55467C2.08307 8.09963 1.56241 9.85978 1.50665 11.6649C1.45089 13.47 1.86192 15.2589 2.69998 16.8586L1.52248 21.5634C1.49491 21.6739 1.49288 21.7893 1.51655 21.9007C1.54022 22.0121 1.58897 22.1167 1.65909 22.2065C1.72921 22.2963 1.81887 22.3689 1.92125 22.4189C2.02363 22.4689 2.13605 22.4948 2.24998 22.4949C2.31143 22.495 2.37265 22.4874 2.43223 22.4724L7.13623 21.2949C8.5471 22.0344 10.1077 22.4431 11.7 22.4903C13.2922 22.5374 14.8743 22.2217 16.3264 21.5669C17.7785 20.9122 19.0627 19.9356 20.0816 18.7112C21.1005 17.4868 21.8275 16.0466 22.2075 14.4997C22.5875 12.9527 22.6105 11.3396 22.2749 9.78246C21.9393 8.2253 21.2537 6.76491 20.2702 5.51188C19.2867 4.25884 18.031 3.246 16.5982 2.55004C15.1653 1.85409 13.5929 1.49326 12 1.49487ZM12 20.9949C10.4604 20.9937 8.94696 20.5975 7.60423 19.8444C7.49221 19.7815 7.36593 19.7484 7.23748 19.7484C7.17602 19.7482 7.11479 19.7558 7.05523 19.7709L3.28123 20.7144L4.22473 16.9396C4.27052 16.754 4.24369 16.5579 4.14973 16.3914C3.18434 14.667 2.81335 12.6728 3.09404 10.7166C3.37473 8.76039 4.29149 6.95096 5.7028 5.56759C7.11411 4.18423 8.94151 3.30384 10.9029 3.06233C12.8644 2.82082 14.8507 3.23161 16.5555 4.2313C18.2602 5.23098 19.5885 6.76397 20.3354 8.59365C21.0822 10.4233 21.2061 12.448 20.6878 14.355C20.1696 16.2621 19.038 17.9456 17.4679 19.1456C15.8977 20.3456 13.9762 20.9955 12 20.9949Z",
    fill: "url(#paint0_linear_44_4382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.49487H7.5C7.30109 7.49487 7.11032 7.57389 6.96967 7.71454C6.82902 7.8552 6.75 8.04596 6.75 8.24487C6.75 8.44379 6.82902 8.63455 6.96967 8.7752C7.11032 8.91586 7.30109 8.99487 7.5 8.99487H16.5C16.6989 8.99487 16.8897 8.91586 17.0303 8.7752C17.171 8.63455 17.25 8.44379 17.25 8.24487C17.25 8.04596 17.171 7.8552 17.0303 7.71454C16.8897 7.57389 16.6989 7.49487 16.5 7.49487Z",
    fill: "url(#paint1_linear_44_4382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.2449H7.5C7.30109 11.2449 7.11032 11.3239 6.96967 11.4645C6.82902 11.6052 6.75 11.796 6.75 11.9949C6.75 12.1938 6.82902 12.3846 6.96967 12.5252C7.11032 12.6659 7.30109 12.7449 7.5 12.7449H16.5C16.6989 12.7449 16.8897 12.6659 17.0303 12.5252C17.171 12.3846 17.25 12.1938 17.25 11.9949C17.25 11.796 17.171 11.6052 17.0303 11.4645C16.8897 11.3239 16.6989 11.2449 16.5 11.2449Z",
    fill: "url(#paint2_linear_44_4382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9949H7.5C7.30109 14.9949 7.11032 15.0739 6.96967 15.2145C6.82902 15.3552 6.75 15.546 6.75 15.7449C6.75 15.9438 6.82902 16.1346 6.96967 16.2752C7.11032 16.4159 7.30109 16.4949 7.5 16.4949H12C12.1989 16.4949 12.3897 16.4159 12.5303 16.2752C12.671 16.1346 12.75 15.9438 12.75 15.7449C12.75 15.546 12.671 15.3552 12.5303 15.2145C12.3897 15.0739 12.1989 14.9949 12 14.9949Z",
    fill: "url(#paint3_linear_44_4382)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_4382",
    x1: 12.0054,
    y1: 1.49487,
    x2: 7.77583,
    y2: 20.1139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6691FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_4382",
    x1: 12,
    y1: 7.49487,
    x2: 11.9546,
    y2: 8.89196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6691FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_4382",
    x1: 12,
    y1: 11.2449,
    x2: 11.9546,
    y2: 12.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6691FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_44_4382",
    x1: 9.75,
    y1: 14.9949,
    x2: 9.67079,
    y2: 16.3889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6691FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_4382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 -0.00512695)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleSvg);
export default __webpack_public_path__ + "static/media/ChatBubbleSVG.7d32350fff83119d0b80d2a5a59d434c.svg";
export { ForwardRef as ReactComponent };